export const getCurrentUser = () => () =>
  fetch('/api/currentUser/', { credentials: 'include' }).then((response) => {
    if (response.status === 200) {
      window.location = process.env.UNICAT_DEFAULT_SERVICE; // redirect to accounts service
    }
    return response;
  });



// WEBPACK FOOTER //
// ./action-creators/user.js